<template>
  <v-app id="app">
    <router-view/>
    <v-toast ref="vtoast" />
  </v-app>
</template>
<script>
/* ============
 * Entry Point
 * ============
 *
 * The entry point of the application.
 */
// eslint-disable-next-line
import Vuetify, {
  VApp, // required
} from 'vuetify/lib';
import gql from 'graphql-tag';
import VToast from '@/components/Toast.vue';

import VNavigation from '@/components/Navigation.vue';

export default {
  /**
   * The name of the application.
   */
  name: 'CarelaIotPlatform',

  components: {
    VApp,
    VNavigation,
    VToast,
  },

  apollo: {
    self: {
      query: gql`query($id: uuid!) {
        user(where: { id: {_eq: $id}}) {
          firstname
          lastname
          email
          role
          group_users {
            group {
              name
              group_owners (where: {
                userId: {
                  _eq: $id
                }
              }) {
                id
              }
            }
          }
        }
      }`,
      variables() {
        if (this.$store.state.auth.authenticated) {
          return { id: this.$store.state.auth.user.idTokenParsed.sub };
        }
        return { id: '' };
      },
      update() {
      },
      result({ data, loading, error }) {
        if (!loading && !error && data) {
          this.$store.dispatch('auth/find', data.user[0]);
        }
      },
    },
  },

  /**
   * Fires when the app has been mounted.
   */
  mounted() {
    this.$root.vtoast = this.$refs.vtoast;
  },
};
</script>

<style lang="scss">
.application {
  background-color: #F5F6FA !important;
}
</style>
